import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dynamicAnchor]'
})
export class DynamicAnchorDirective {

  constructor( public viewContainerRef: ViewContainerRef ) { }
}
